import { wrapClientApiCall } from "@kelbongoo/shared-client-react-v2/dist/components/SharedBase/wrapClientApiCall";

export const toggleCompleted = ({
  globalorder_id,
  locale,
  createAlert,
  refreshData,
  excludedLocales
}) => (producerproduct_id) => () => {

  const caller = wrapClientApiCall({
    url: 'globalorders/toggle-golpps-completed',
  });

  return caller({
    params: {
      globalorder_id,
      locale,
      producerproduct_id,
      userId: '2W8X2SaMhytesy4ne',
      excludedLocales,
      isND: true
    }
  })
    .then(() => refreshData())
    .catch((err) => createAlert({ message: err.message }));
};